/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Target_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Choose a target folder..." |
*
* @param {Audio_Embed_Export_Target_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_target_placeholder = /** @type {((inputs?: Audio_Embed_Export_Target_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Target_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Choisissez un dossier cible...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie einen Zielordner aus...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona una cartella di destinazione...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите целевую папку...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccione una carpeta de destino...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择目标文件夹……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("対象フォルダを選択してください...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लक्ष्य फ़ोल्डर चुनें...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione uma pasta de destino...")
	return /** @type {LocalizedString} */ ("Choose a target folder...")
});